import { attr, resolvesTo, defineModel } from 'customer-flows/utils/quote/models'

export default defineModel({
  refid: attr(),
  activityId: attr('strict'),
  availabilityTimeId: attr('strict'),
  tickets: resolvesTo('tickets', 'strict'),
  questionAnswers: resolvesTo('questionAnswers')
})
